import { handleResponse } from "../../helpers/handleresponse";
import { authHeader } from "../../helpers/authHeader";

export const eventLabelService = {
  getGroup,
  create

}

async function create(eventId, name, groupName, languageCode) {
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify({ eventId, name, groupName, languageCode: languageCode })
  };

  return fetch(`./api/eventLabel`, requestOptions)
    .then(handleResponse)
    .then(label => {
      return label;
    });
}
async function getGroup(eventId, groupName, langCode) {
  if(eventId && groupName && langCode){
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" }),
  };
    return fetch(`./api/eventLabel/getgroup/${eventId}?groupName=${groupName}&languageCode=${langCode}`, requestOptions)
    .then(handleResponse)
    .then(group => {
      return group;
    });
  }
}

